<template>
  <qc-container title="在线客服">
    <template #title-right v-if="source===2">
      <!-- 加盟商-可以主动联系客户 -->
      <div class="custom-btn-box">
        <div @click="openCustomer">联系客户</div>
      </div>
    </template>
    <div class="chat-box">
      <div class="chat-iframe">
        <iframe
          allow="clipboard-read; clipboard-write " id="boardFrame" height="100%" width="100%" frameborder="0" scrolling="no"
          src="/static/chat/index.html"
        ></iframe>
      </div>
    </div>
    <order-info ref="orderInfo"></order-info>
    <goods-detail-mobile ref="goodsDetail"></goods-detail-mobile>
    <customer-dialog ref="customer" @open="openChat"></customer-dialog>
  </qc-container>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import OrderInfo from "@view/order/op/order-info.vue";
import GoodsDetailMobile from "@view/components/goods/goods-detail-mobile.vue";
import CustomerDialog from "@org/customer/components/customer-dialog.vue";
import BButton from "@/components/el/b-button.vue";

export default {
  name: "index",
  components: {BButton, CustomerDialog, GoodsDetailMobile, OrderInfo, QcContainer},
  data() {
    return {
      //imAppId:1400599031,
      imAppId:1600086304,
      source:source,
    }
  },
  mixins: [tableBase],
  methods: {
    openChat(row){
      this.sendMessage("openChat",{userId:row.userId});
    },
    openCustomer(){
      this.$refs.customer.show();
    },
    loadIframe() {
      this.simplePost("/api/mgr/business/shop/info/getUserSig",null,res=>{
        this.sendMessage("login",{imAppId:this.imAppId,userSig:res.data.userSign,userID:res.data.identity});
      })
    },
    receiveMessage(e) {
      //接收到消息
      if(typeof e.data == "string"){
        let data = JSON.parse(e.data);
        switch (data.method){
          //可以初始化
          case "im-page-loaded":
            this.loadIframe();
            break;
          case "goods-element-click":
            let goods = data.result.data;
            this.$refs.goodsDetail.openDrawer(goods.id,goods.goodsType||0);
            break;
          case "order-element-click":
            let order = data.result.data;
            this.$refs.orderInfo.openDrawer(order.id);
            break;
        }
      }
    },
    sendMessage(method, data) {
      const dataObj = { method: method, data: data }
      console.log("发送消息",JSON.stringify(dataObj))
      document.getElementById('boardFrame').contentWindow.postMessage(dataObj, '*')
    },
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage, false)


  },
  beforeUnmount() {
    window.removeEventListener('message', this.receiveMessage, false)
  }
}
</script>


<style lang="less" scoped>
.chat-box{
  min-height: 80vh;
  display: flex;
  justify-content: center;
  .chat-iframe{
   width: 80vw;
   height: 80vh;
 }
}
.custom-btn-box{
  float: right;
  cursor: pointer;
  color: @primary;
  font-size: 14px;
  font-weight: normal;
  &:hover{
    opacity: 0.8;
  }
}
</style>
